
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import PreviewHtml from '@/views/main/forms/PreviewHtml.vue';
import RendererPreviewContent from '@/components/forms/RendererPreviewContent.vue';
import {dispatchCreateAccessLog, dispatchCreatePrinterLog} from '@/store/main/actions';
import {readCurrentPrinterLog, readHasModuleAccess, readUserProfile} from '@/store/main/getters';
import {IPrinterLog} from '@/interfaces/printer-logs';

@Component({
  components: {RendererPreviewContent, PreviewHtml},
})
export default class FormValuePreview extends Vue {
  @Prop() public formValueId!: any;

  private dialog: boolean = false;
  private canPrint: boolean = false;
  private canSign: boolean = false;

  @Watch('dialog')
  public async watchFormValueId(val) {
    if (val) {
      await dispatchCreateAccessLog(this.$store, {
        module_name: 'form_values',
        method: 'read',
        document_id: this.formValueId,
      });
    }
  }


  private get currentUser() {
    return readUserProfile(this.$store);
  }

  public async mounted() {
    this.canSign = readHasModuleAccess(this.$store)({module: 'form_values', method: 'can_sign'});
    this.canPrint = readHasModuleAccess(this.$store)({module: 'form_values', method: 'print'});
  }

  private async printPdf(hasSignature) {
    await new Promise((resolve, reject) => setTimeout(() => resolve(), 500));
    const {route} = this.$router.resolve({
      name: 'preview-report', params: {id: this.formValueId},
      query: {has_signature: hasSignature, full_name: `${this.currentUser?.id}_${this.currentUser?.fullname}`},
    });
    window.open(route.fullPath, '_target');
  }

}
